<template>
  <div class="sub-summary">
    <h3>Subscription Summary</h3>

    <div class="sub-summary__choices">
      <div class="sub-summary__choice" v-for="(value, index) in subscription" :key="index">
        <span class="sub-summary__option">{{ value.summaryHeading }}</span>
        <span class="sub-summary__selection">{{ values[value.slug] ? formattedValue(value.slug, values[value.slug]) : "-" }}</span>
      </div>
    </div>

    <div class="sub-summary__totals" v-if="pricing !== 0">
      <div class="sub-summary__price">
        {{ pricing | currency }} Recurring payment
      </div>
      <div class="sub-summary__shipping">
        Includes {{ shipping | currency }} Shipping
      </div>
    </div>

    <form class="wooform" method="POST">
      <input type="hidden" name="suborder" value="true" />
      <input type="hidden" v-for="(value, index) in formSub" :key="index" :name="value.slug" :value="formValues[value.slug]" />
      <input type="hidden" name="Variety Selection" value="Single Origin">
      
      <span v-if="subSwitch">
        <input type="hidden" v-for="(value, key, index) in subSwitch" :key="index" :name="key" :value="value" />
      </span>

      <input v-if="shouldLetUserComplete" class="sub-summary__submit" type="submit" value="Go to Basket" />
    </form>
  </div>
</template>

<script>

export default {
  props: {
    subscription: {
      type: Array,
      default: [],
    },
    values: {
      type: Object,
      default: {}
    },
    houseFilterPricing: {
      type: Object, 
      default: []
    },
    houseEspressoPricing: {
      type: Object, 
      default: []
    },
    decaffFilterPricing: {
      type: Object, 
      default: []
    },
    decaffEspressoPricing: {
      type: Object, 
      default: []
    },
    singlePricing: {
      type: Object, 
      default: []
    }, 
    capsuleHousePricing: {
      type: Object, 
      default: []
    },
    capsuleSinglePricing: {
      type: Object,
      default: []
    },
    capsuleDecaffPricing: {
      type: Object,
      default: []
    },
    shipping: {
      type: Number, 
      default: []
    },
    subSwitch: {
      type: [Object, Boolean],
      default: () => false
    }
  },
  methods: {
    formattedValue(key, value) {
      if (key === 'Quantity') {
        if (value === '1') {
          return '250G'
        } else if (value === '2') {
          return '2x 250G'
        } else if (value === '4') {
          return '1kg'
        } else {
          return value
        }
      } else if (key === 'frequency') {
        if (value === '1') {
          return 'EVERY DAY'
        } else {
          return `EVERY ${value} DAYS`
        }
      } else {
        return value
      }
    }
  },
  computed: {
    pricing() {
      let basePrice = 0

      if (this.values.Coffee === '' || this.values.Quantity === '') {
        return basePrice
      }

      if (this.values.Quantity === "1") {
        basePrice = parseFloat(this.singlePricing['250g']);
      } else if (this.values.Quantity === "2") {
        basePrice = parseFloat(this.singlePricing['500g']);
      } else {
        basePrice = parseFloat(this.singlePricing['1kg'])
      }

      if (basePrice === 0) {
        return 0
      } else {
        return basePrice + this.shipping
      }
    },
    formSub() {
      // return this.subscription.filter(v => v.slug == 'Coffee');

      if (this.values.Coffee === 'Espresso') {
        return [... this.subscription, {
            slug: 'Grind',
            displayValue: 'Wholebean',
            value: 'Wholebean'
          }]
      } else {
        return this.subscription
      }
    },
    formValues() {
      if (this.values.Coffee === 'Espresso') {
        const val = this.values

        val.Grind = 'Wholebean'

        return val
      } else {
        return this.values
      }
    },
    shouldLetUserComplete() {
      if (this.values.Coffee === 'Capsules') {
        if (this.values.Quantity.length === 0 || this.values.frequency.length === 0) {
          return false;
        } 
      } else {
        for (let [key, value] of Object.entries(this.values)) {
          if (value.length === 0) return false;
        }
      }
      return true
    }
  }
} 
</script>